import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface OrderListParams {
  page: number;
  limit?: number;
  search?: string;
  status?: string;
  tab?: string;
  view?: string;
}

interface NavigationState {
  orderListParams: OrderListParams;
  saveOrderListParams: (params: OrderListParams) => void;
}

export const useNavigationStore = create<NavigationState>()(
  persist(
    (set) => ({
      orderListParams: { page: 1 },
      saveOrderListParams: (params) => set({ orderListParams: params }),
    }),
    {
      name: 'admin-navigation',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
